import React from "react";
import { Controller, UseFormReturn } from "react-hook-form";
import {
  Box,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";

type MarketCompetitionSettingProps = {
  control: UseFormReturn["control"];
  translate: (_key: string) => string;
};
export const MarketCompetitionSetting: React.FC<
  MarketCompetitionSettingProps
> = ({ control, translate }) => {
  return (
    <Box
      display="flex"
      flexDirection={{ xs: "column", sm: "row" }}
      alignItems="center"
      mb={2}
      gap={2}
    >
      <Typography
        variant="body2"
        fontWeight="bold"
        sx={{ width: { xs: "100%", sm: "20%" }, mb: { xs: 1, sm: 0 } }}
      >
        {translate("updatePricing.label")}
      </Typography>
      <Box
        display="flex"
        alignItems="center"
        sx={{ width: { xs: "100%", sm: "80%" } }}
      >
        <Controller
          name="updatePricing"
          control={control}
          render={({ field: { onChange, value } }) => (
            <RadioGroup
              value={value}
              onChange={(e) => onChange(e.target.value)}
            >
              <FormControlLabel
                value="DONT_UPDATE_PRICING"
                control={<Radio />}
                label={translate("updatePricing.dontUpdatePricing")}
              />
              <FormControlLabel
                value="DONT_UPDATE_AMAZON"
                control={<Radio />}
                label={translate("updatePricing.dontUpdateAmazon")}
              />
              <FormControlLabel
                value="SMART_PRICING"
                control={<Radio />}
                label={translate("updatePricing.smartPricing")}
              />
            </RadioGroup>
          )}
        />
      </Box>
    </Box>
  );
};
